/**
 * Checks if the current environment is BounceUOttawa
 * Based on the isBounceUOttawa flag set on the window object
 * @returns true if in BounceUOttawa environment, false otherwise
 */
export const isBounceUOttawa = (): boolean =>
  typeof window !== 'undefined' && (window as any).isBounceUOttawa;
